<template lang="pug">
	main
		section.errorpage
			div.details
				span 404 Error
				h1 Oops, something went wrong!
				p.
					We can't seem to find the page you're looking for.
					Go to our <a href="/" title="Back to home page">home page</a>
</template>

<script>
import Vue from 'vue';
import store, {ABSPATH} from './../store';

export default {
	name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue